export const themePreferences = ["light", "dark", "system"];
export const themeStorageKey = "autar.theme";

export function resolveThemePreference(saved) {
  return themePreferences.includes(saved) ? saved : "system";
}
